import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import ActiveSystems from "./ActiveSystems";
import ActiveSignificantDeficiencies from "./ActiveSignificantDeficiencies";
import ResolvedSignificantDeficiencies from "./ResolvedSignificantDeficiencies";
import UnderEnforcement from "./UnderEnforcement";
import PrevMonthDefEnf from "./PrevMonthDefEnf";
import PrevYearDefEnf from "./PrevYearDefEnf";

const enforcementsMenu = [
  { label: "Selected Deficiency Report", value: "selected-def-report" },
  { label: "Worst 25 Reports", value: "worst-25-reports" }
];

const style = {
  control: (base) => ({
    ...base,
    border: "1px solid grey",
    // This line disable the blue border
    boxShadow: "none"
  })
};

const EnfDashboardHomePage = () => {
  let history = useHistory();
  return (
    <React.Fragment>
      <div className="page-container enf-dashboard-home-container">
        <Row>
          <Col md={4}>
            <Link to='/' className='m-2 hyperlink' cypressid='homePage'>
              Home
            </Link>
            <span className='m-2'> | </span>
            <Link to='/secure/module-index' className='m-2 hyperlink' cypressid='modulesIndexPage'>
              Modules
            </Link>
          </Col>
          <Col>
            <Select
              placeholder='Select Rules & Enforcements Report'
              options={enforcementsMenu}
              isClearable
              isSearchable
              className='mb-4 w-50 float-end'
              onChange={(evt) => history.push(`/secure/enforcements/${evt.value}`)}
              styles={style}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='enfDashboardHomePage'>
              <h3 style={{ color: "#fff" }}>Statewide Performance Metrics</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <ActiveSystems />
            <br />
            <br />
          </Col>
          <Col>
            <UnderEnforcement />
            <br />
            <br />
          </Col>
        </Row>
        <Row>
          <Col>
            <PrevMonthDefEnf />
            <br />
            <br />
          </Col>
          <Col>
            <PrevYearDefEnf />
            <br />
            <br />
          </Col>
        </Row>
        <Row>
          <Col>
            <ActiveSignificantDeficiencies />
            <br />
            <br />
          </Col>
          <Col>
            <ResolvedSignificantDeficiencies />
            <br />
            <br />
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default EnfDashboardHomePage;
